export interface IState {
    customerLeadList: any;
    customerLeadCount: number;
  }
  
  type Action = any;
  
  export const customerLeadReducer = (
    state: IState = {
      customerLeadList: [],
      customerLeadCount: 0,
    },
    action: Action
  ): any => {
    switch (action.type) {
    //   case "GET_CUSTOMER_ESTIMATE":
    //     return {
    //       ...state,
    //       customerEstimateList:
    //         action?.payload?.page == 1
    //           ? action?.payload?.data
    //           : [...state?.customerEstimateList, ...action?.payload?.data],
    //       customerLeadCount: action?.payload?.count,
    //     };
  
      default:
        return state;
    }
  };
  